function HowPickUpWorks() {
  return (
    <>

      <p style={{ color: "rgb(51, 51, 51)", textAlign: "justify" }}>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          1.
          {" "}

          <b>Order parts online</b>
          , choose the
        </span>

        <span style={{ fontWeight: "600" }}>

          <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>&nbsp;“pick up”</span>
        </span>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          &nbsp;option at checkout, if available. (If this option is not
          available, then unfortunately they are not eligible for a local
          pickup). Currently, we have
          {" "}

          <b>
            Pick-up &amp; Return Services only in GTA, Brampton Area.
          </b>
          .
        </span>

        <br />
      </p>

      <p style={{ color: "rgb(51, 51, 51)", textAlign: "justify" }}>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>2. Wait for an&nbsp;</span>

        <span style={{ fontWeight: "600" }}>

          <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>SMS</span>
        </span>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          &nbsp;notification, indicating parts are ready at our local pickup
          location.
        </span>
      </p>

      <p style={{ color: "rgb(51, 51, 51)", textAlign: "justify" }}>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>3.&nbsp;</span>

        <span style={{ fontWeight: "600" }}>

          <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>Curbside Pick-Up</span>
        </span>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          &nbsp;is available in
        </span>

        <span style={{ fontWeight: "600" }}>

          <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>&nbsp;Edmonton Area.</span>
        </span>
      </p>

      <p style={{ color: "rgb(51, 51, 51)", textAlign: "justify" }}>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          4. Arrive with your Order ID and a photo ID, between&nbsp;
        </span>

        <span style={{ fontWeight: "600" }}>

          <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>10 AM – 4:30 PM EST Mon-Fri</span>
        </span>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          . (Timings will be different for all other regions). Stay Tuned for
          updates on your local city pickup location!
        </span>
      </p>

      <p style={{ color: "rgb(51, 51, 51)", textAlign: "justify" }}>

        <span style={{ fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>

          <br />
        </span>
      </p>

      <p style={{ color: "rgb(51, 51, 51)", textAlign: "justify" }}>

        <span style={{ fontWeight: "600", textAlign: "start" }}>

          <span style={{ fontSize: "calc(1.4 * var(--safari-root-font, 10px))", lineHeight: "calc(1.926 * var(--safari-root-font, 10px))" }}>

            <span style={{ color: "#d6a5bd" }}>
              *Note: We do not SELL directly at the Pick Up Location, it is only
              pick up, drop-off &amp; returns. We do not accept payment or do
              refunds at the locations.
            </span>
          </span>
        </span>
      </p>
    </>
  );
}

export default HowPickUpWorks;
